export enum FilterKeys {
  OnboardingRequests = 'OnboardingRequests',
  ContractRequests = 'ContractRequests',
  Spacializations = 'Spacializations',
  Contracts = 'Contracts',
  RequestTemplates = 'RequestTemplates',
  ActionTemplates = 'ActionTemplates',
  ExceptionRequests = 'ExceptionRequests',
  RetailExceptionRequests = 'RetailExceptionRequests',
  RetailRequests = 'RetailRequests',
  RetailOnboardingRequests = 'RetailOnboardingRequests',
  BPRegistrationRequests = 'BPRegistrationRequests',
  SimplePartnerRegistrations = 'SimplePartnerRegistrations',
  BPReconfirmationsRequests = 'BPReconfirmationsRequests',
}
